export default "/assets/images/cooking-video.mp4?83d734af2f9d6799c3d4e9a01bdf1448";